// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewManager_container__UUOXa"};